var React = require('react');

function CloseRounded (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.2997 5.69942C17.9097 5.31012 17.2797 5.31012 16.8897 5.69942L11.9997 10.5707L7.10973 5.68944C6.71973 5.30014 6.08973 5.30014 5.69973 5.68944C5.30973 6.07874 5.30973 6.7076 5.69973 7.0969L10.5897 11.9781L5.69973 16.8593C5.30973 17.2486 5.30973 17.8775 5.69973 18.2668C6.08973 18.6561 6.71973 18.6561 7.10973 18.2668L11.9997 13.3856L16.8897 18.2668C17.2797 18.6561 17.9097 18.6561 18.2997 18.2668C18.6897 17.8775 18.6897 17.2486 18.2997 16.8593L13.4097 11.9781L18.2997 7.0969C18.6797 6.71759 18.6797 6.07874 18.2997 5.69942Z","fill":"#F8F8FA"}));
}

CloseRounded.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseRounded;

CloseRounded.default = CloseRounded;
